(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qca-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('qca-product-video')) {
    customElements.define('qca-product-video', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('button');
        const template = this.querySelector('template');
        if (!button || !template || this.dataset.ready) return;
        this.dataset.ready = 'true';
        button.addEventListener('click', () => {
          const iframe = template.content.querySelector('iframe')?.cloneNode(true);
          if (!iframe) return;
          const source = new URL(iframe.getAttribute('src'), window.location.href);
          source.searchParams.set('autoplay', '1');
          iframe.src = source.href;
          const permissions = iframe.getAttribute('allow') || '';
          if (!permissions.includes('autoplay')) iframe.setAttribute('allow', permissions + '; autoplay');
          if (!iframe.title) iframe.title = this.dataset.title;
          iframe.tabIndex = 0;
          this.replaceChildren(iframe);
          iframe.focus();
        }, { once: true });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
